import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SpreadsheetSection from './components/SpreadsheetSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedProductsSection from './components/FeaturedProductsSection';
import BeginnerSection from './components/BeginnerSection';
import ReviewSection from './components/ReviewSection';
import PillarArticlesSection from './components/PillarArticlesSection';
import ShippingSection from './components/ShippingSection';
import SafetySection from './components/SafetySection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';

export default function HomePage() {
  const { i18n } = useTranslation('common');
  const location = useLocation();

  useEffect(() => {
    const lang = location.pathname.split('/')[1];
    if (lang && ['en', 'pt', 'de'].includes(lang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, i18n]);

  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Navbar />
      <main>
        <HeroSection />
        <SpreadsheetSection />
        <CategoriesSection />
        <FeaturedProductsSection />
        <BeginnerSection />
        <ReviewSection />
        <PillarArticlesSection />
        <ShippingSection />
        <SafetySection />
        <TrustSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}